module.exports = __webpack_public_path__ + "img/tinymce.7262d90.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/tinymce/skins/lightgray/fonts/tinymce.svg
// module id = 1098
// module chunks = 0